import { ApiStateSingle, StateManager } from 'services';
import Cookies from 'js-cookie';
import jwtDecode from 'jwt-decode';
import { logoutAllTabs } from 'services/logoutSync';
import { monitor, flushMonitoring } from 'services/monitoring';
import * as types from './types';

import {
  API_URL,
  DOMAIN,
  ENVIRONMENT,
} from 'settings';
import { DecodedToken } from 'services/Api/checkIfTokenExpired';

type State = ApiStateSingle<types.Auth>;

const apiUrl = `${API_URL}/auth`;

const token = Cookies.get(`pm_${ENVIRONMENT}_token`);
let decodedToken: any = {};
try {
  if (token) decodedToken = jwtDecode(token);
} catch (e) {}

export const authManager = new StateManager({
  apiUrl,
  moduleName: 'auth',
  initialState: {
    item: {
      token,
      userId: decodedToken['user_id'],
      username: decodedToken['username'],
      userType: decodedToken['user_type'],
      email: decodedToken['email'],
      selected_person: Cookies.get(`pm_${ENVIRONMENT}_person`),
    },
    waiting: false,
  },
});

const loginReducer = (
  state: State,
  result: { access: string; refresh: string }
) => {
  // console.log('LOGIN REDUCER ====================');
  // console.log('result: ', result);
  const { access, refresh } = result;
  // console.log('token: ', access);
  // console.log('refresh: ', refresh);
  let decodedToken: any;
  try {
    decodedToken = jwtDecode(access) as any;
    state.item = {
      token: result.access,
      refresh: result.refresh,
      userId: decodedToken['user_id'],
      username: decodedToken['username'],
      userType: decodedToken['user_type'],
      email: decodedToken['email'],
      selected_person: state.item.selected_person,
    };
    const decodedRefresh = jwtDecode(refresh) as any;
    // console.log('decoded token: ', decodedToken);
    // console.log('userId: ', decodedToken['user_id']);
    // console.log('username: ', decodedToken['username']);
    // console.log('user_type: ', decodedToken['user_type']);
    // console.log('email: ', decodedToken['email']);
    Cookies.set(`pm_${ENVIRONMENT}_token`, result.access, {
      sameSite: 'Strict',
      domain: `${DOMAIN}`,
    });
    Cookies.set(`pm_${ENVIRONMENT}_token_exp`, decodedToken['exp'], {
      sameSite: 'Strict',
      domain: `${DOMAIN}`,
    });
    Cookies.set(`pm_${ENVIRONMENT}_refresh`, result.refresh, {
      sameSite: 'Strict',
      domain: `${DOMAIN}`,
    });
    Cookies.set(`pm_${ENVIRONMENT}_refresh_exp`, decodedRefresh['exp'], {
      sameSite: 'Strict',
      domain: `${DOMAIN}`,
    });
  } catch (e) {
    console.log('login error: ', e);
  }
};

const refreshReducer = (state: State, result: { access: string }) => {
  // console.log('REFRESH REDUCER ====================');
  // console.log('result: ', result);
  const { access } = result;
  // console.log('access: ', access);
  let decodedToken: any;
  try {
    decodedToken = jwtDecode(access) as DecodedToken;
    // console.log('decoded token: ', decodedToken);
    // console.log('userId: ', decodedToken['user_id']);
    // console.log('username: ', decodedToken['username']);
    // console.log('user_type: ', decodedToken['user_type']);
    // console.log('email: ', decodedToken['email']);
    state.item = {
      token: result.access,
      // refresh: result.refresh,
      userId: decodedToken['user_id'],
      username: decodedToken['username'],
      userType: decodedToken['user_type'],
      email: decodedToken['email'],
      selected_person: state.item.selected_person,
    };
    Cookies.set(`pm_${ENVIRONMENT}_token`, result.access, {
      domain: `${DOMAIN}`,
    });
    Cookies.set(`pm_${ENVIRONMENT}_token_exp`, decodedToken['exp'], {
      domain: `${DOMAIN}`,
    });
    // Cookies.set('refresh', result.refresh);
  } catch (e) {
    console.log('login error: ', e);
  }
};

export const login = authManager.createApi<
  { username: string; password: string },
  { access: string; refresh: string },
  State
>('LOGIN', {
  path: '/get_token',
  method: 'POST',
  successReducer: loginReducer,
});

export const refreshToken = authManager.createApi<
  { refresh: string | undefined },
  { access: string },
  State
>('REFRESH_TOKEN', {
  path: '/refresh_token',
  method: 'POST',
  successReducer: refreshReducer,
  failReducer: state => {
    state.item.token = undefined;
    state.item.refresh = undefined;
    state.error = undefined;
    Cookies.remove(`pm_${ENVIRONMENT}_token`, { domain: `${DOMAIN}` });
    Cookies.remove(`pm_${ENVIRONMENT}_token_exp`, { domain: `${DOMAIN}` });
    Cookies.remove(`pm_${ENVIRONMENT}_refresh`, { domain: `${DOMAIN}` });
    Cookies.remove(`pm_${ENVIRONMENT}_refresh_exp`, { domain: `${DOMAIN}` });
    Cookies.remove(`pm_${ENVIRONMENT}_person`, { domain: `${DOMAIN}` });
    Cookies.remove(`pm_${ENVIRONMENT}_soundEnabled`);
  },
});

export const logout = authManager.createLocalEvent('LOGOUT', state => {
  monitor('auth.logout');
  flushMonitoring(true);
  state.item.token = undefined;
  state.selected_person = undefined;
  logoutAllTabs();
});

export const selectPerson = authManager.createLocalEvent(
  'SELECT_PERSON',
  (state: State, payload: number) => {
    state.item.selected_person = payload;
    Cookies.set(`pm_${ENVIRONMENT}_person`, `${payload}`, {
      domain: `${DOMAIN}`,
    });
  }
);
